export function useLabels() {
	const {absoluteImagePath} = useText();
	const nuxtApp = useNuxtApp();
	const lang = useLang();

	async function fetch(options) {
		const language = options?.lang ? options.lang : lang.get();
		return useApi('/api/nuxtapi/labels?lang=' + language, null, {cache: true}).then(res => {
			nuxtApp.$appData.labels = res.data;
			return res.data;
		});
	}

	const get = (code, d = '') => {
		const labels = nuxtApp.$appData?.labels;

		// If code is not provided, return all labels
		if (!code) return labels;

		if (labels) {
			// If default is set to 'code' then return the label code. Otherwise return whatever is set as default. If nothing is set as default, return empty string
			const defaultLabel = d === 'code' ? code : nuxtApp.$appData.labels[d] || d || '';
			let l = nuxtApp.$appData.labels[code] ? absoluteImagePath(nuxtApp.$appData.labels[code]) : defaultLabel;

			// Replace public/media path
			if (l) l = l.replace(/(^|["'=\s])\/media\//g, '$1/');

			return l;
		}
		if (import.meta.client) console.warn('No labels available');
		return '';
	};

	async function set(data) {
		return (nuxtApp.$appData.labels = data);
	}

	return {labels: get(), fetch, get, set};
}
